import { environment } from "../../../environments/environment";
import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AppConstants } from "./app-constants";

export class StackedBarChartConstants {
  stackedBarChartImgFolderPath: string = "../../../assets/Images/StackedBarChart/";
  /*baseUrl: string = environment.baseUrl;*/
  stackedBarChartModuleRoutePath = AppConstants.stackedBarChartCategoryPathMap.chartModuleRoutePath + "/";
  chartDescriptions: any = this.getChartDescriptions();
  stackedBarChartModuleComponentPath: string = AppConstants.stackedBarChartCategoryPathMap.moduleFolderPath;

  //contains the details of all kinds of stacked charts that is available in th tool
  stackedBarChartTypes: ChartSelectionCard[] = [
    {
      "imgUrl": "",
      routePath: this.stackedBarChartModuleRoutePath + "StackedBarChart1Custom",
      routePath2: this.stackedBarChartModuleRoutePath + "StackedBarChart1Custom",
      description: [],
      chartFolderPath: this.stackedBarChartModuleComponentPath + "stacked-bar-chart1",
      chartFolderPath2: this.stackedBarChartModuleComponentPath + "stacked-bar-chart3",
      imgClassName: "verticalStackedBarImg",
      chartTitle: "Vertical Stacked Chart",
      chartId: 1,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Stack bar chart"
    },
    {
      "imgUrl": "",
      routePath: this.stackedBarChartModuleRoutePath + "StackedBarChart2Custom",
      routePath2: this.stackedBarChartModuleRoutePath + "StackedBarChart2Custom",
      description: [],
      chartFolderPath: this.stackedBarChartModuleComponentPath + "stacked-bar-chart2",
      chartFolderPath2: this.stackedBarChartModuleComponentPath + "stacked-bar-chart4",
      imgClassName: "horizontalStackedBarImg",
      chartTitle: "Horizontal Stacked Chart",
      chartId: 2,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Stack bar chart"
    },
    //{
    //  "imgUrl": this.stackedBarChartImgFolderPath + "07stackchart.png",
    //  routePath: this.stackedBarChartModuleRoutePath + "StackedBarChart7",
    //  description: this.chartDescriptions.genericStackedBarChartDescription,
    //  chartFolderPath: this.stackedBarChartModuleComponentPath + "stacked-bar-chart7"
    //}
  ]

  //Returns the descriptions that has to be displayed in customization section of each stacked bar chart
  getChartDescriptions() {
    let chartDescription = {
      stackedBarChart1: [
        "Bar colour: solid single colour, solid multicolour, linear gradient colour (two variation colour).",
        "Bar texture (repeated pattern) can be applied.",
        "Customize bar shadow can be applied.",
        "Bar background colour can be solid or linear gradient.",
        "X-Axis: Text, image and both (text/image) can be added.",
        "X-axis text can be single colour or solid multicolour.",
        "Y-axis label line can be dotted or solid line.",
        "Data label can be fixed position or absolute position (above each bar chart). \
          In data label you can add text, formatter (text or glyph font icon)."
      ],

      stackedBarChart2: [
        "Stack Bar colour: solid single colour, solid multicolour, linear gradient colour (two variation colour).",
        "For the dot placed and labels on x-axis, formatter is used inside the labels.",
        "Grid lines in both x-axis and y-axis can be solid, long dash, short dash etc. \
          according to the requirements and can be provided with different styles.",
        "On x-axis text, images can be added.",
        "Y-axis line can be solid or in any other styled format.",
        "Data Labels-For the different colour on top of columns formatter is used that \
          returns value as well as the colour from the data."
      ],

      genericStackedBarChartDescription: [
        "Stack Bar colour: solid single colour, solid multicolour, linear gradient colour (two variation colour).",
        "Grid lines in both x-axis and y-axis can be solid, long dash, short dash etc. \
            according to the requirements and can be provided with different styles.",
        "On x-axis text, images can be added.",
        "Y-axis line can be solid or in any other styled format."
      ]
    }

    return chartDescription;
  }
}
